
import Vue from "vue";
import { printHumanFloat, printLocalDate } from "@/utils/pretty-print";
import {IButton} from "@/models/dossier-configs/cashier";

export default Vue.extend({
	filters: {
		printHumanFloat,
		printLocalDate
	},
	props: {
		button: {
			type: Object as () => IButton,
			required: true
		}
	},
	methods: {
		getTextColor(bgColor:string) {
			const rgb = this.hexToRgb(bgColor);
			const brightness = (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
			return brightness > 125 ? "#000000" : "#ffffff";
		},
		hexToRgb(hex:string) {
			if(!hex){
				hex = "#ffffff";
			}
			const bigint = parseInt(hex.slice(1), 16);
			const r = (bigint >> 16) & 255;
			const g = (bigint >> 8) & 255;
			const b = bigint & 255;
			return { r, g, b };
		},
		add(){
			this.$emit("add",this.button);
		}
	}
});
